<script>
import TipperComponent from "../components/TipperComponent.svelte";

  export let title = 'Why Choose Curbza?';
  let tippers = [
    {
      title: 'A robust marketplace where your assets can shine to the right buyers',
      description: 'Curbza\'s platform is designed to cater for the needs of businesses and other organizations.',
      direction: 'ltr',
      featuredImage: '/assets/images/why-curbza-01.jpg',
      features: [
        {
          icon: 'assets/images/icons/marketplace-management-icon.svg',
          name: 'Marketplace management',
          items: [
            'Catalog moderation',
            'Activity overview',
          ]
        },
        {
          icon: 'assets/images/icons/product-management-icon.svg',
          name: 'Product management',
          description: 'Create and manage product listings with ease using simple yet powerful tools like',
          items: [
            'Rich text editor',
            'Image uploader',
          ]
        },
      ]
    },
    {
      title: 'Easy access to messaging and transaction correspondance',
      description: 'Simplify communication and keep your buyers and suppliers up-to-date with Curbza\'s in-app messaging service.',
      direction: 'rtl',
      featuredImage: '/assets/images/why-curbza-02.jpg',
      features: [
        {
          icon: 'assets/images/icons/order-processing-icon.svg',
          name: 'Order processing and management',
          items: [
            'Notify your providers about newly received orders',
            'Track orders',
          ]
        },
        {
          icon: 'assets/images/icons/communication-icon.svg',
          name: 'Product management',
          items: [
            'In-app messenger for peer-to-peer communication with smart tagging',
            'Notifications, alerts',
            'Client feedback, reviews',
          ]
        },
      ]
    },
    {
      title: 'Powerful Management & Intelligent Capability',
      description: 'Use the power of smart search and organizational capability to expand your reach and achieve new heights.',
      direction: 'ltr',
      featuredImage: '/assets/images/why-curbza-03.jpg',
      features: [
        {
          icon: 'assets/images/icons/product-search-icon.svg',
          name: 'Product search and display',
          items: [
            'Powerful product search',
            'Faceted categorey filters and well-designed, informative product page.',
          ]
        },
        {
          icon: 'assets/images/icons/marketing-features-icon.svg',
          name: 'Marketing features',
          items: [
            'Automated search engine optimization',
            'Social media integrations',
            'Clean and user-friendly UI/MX',
          ]
        },
      ]
    },
  ]
</script>

<style>
  #why-curbza {
    background-color: var(--panel);
    color: var(--panel-text);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3vw;
  }
</style>

<main id="why-curbza">
  <h1 class="title margin-bottom-4vw">{title}</h1>
  {#each tippers as tipper}
  <TipperComponent
    title={tipper.title}
    description={tipper.description}
    direction={tipper.direction}
    featuredImage={tipper.featuredImage}
    features={tipper.features} />
  {/each}
</main>
